import CompactFooter from 'components/Footer/CompactFooter/CompactFooter';

export default CompactFooter;
